// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeInviteBulkPreviewBody = {
  poolId: string;
  source: "chat" | "pool";
  sourceId: string;
};

export type typeInviteBulkPreviewOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    candidates: {
      userId: string;
      displayName: string;
      avatarUrl?: string | null;
    }[];
    excludedCount: number;
    alreadyIn?: {
      userId: string;
      displayName: string;
      relation: "member" | "invited";
    }[];
  };
};

export type typeInviteBulkPreviewOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteBulkPreviewOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteBulkPreviewOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaInviteBulkPreviewBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    source: { type: "string", enum: ["chat", "pool"] },
    sourceId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "source", "sourceId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createInviteBulkPreview(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaInviteBulkPreviewBody);
  }

  return async function postInviteBulkPreview(
    payload: typeInviteBulkPreviewBody,
  ): Promise<typeInviteBulkPreviewOutput200 | typeInviteBulkPreviewOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postInviteBulkPreview" failed before calling the network. #7bf988bff1b8`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#7bf988bff1b8" },
        },
        data: null,
      } as typeInviteBulkPreviewOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/invite/bulk-preview`,
      httpMethod: "POST",
      options,
    })) as typeInviteBulkPreviewOutput200 | typeInviteBulkPreviewOutput400;
  };
}
